module.exports = __webpack_public_path__ + "img/aboutShengrongAn_6.45880fa2.png";